var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.62426 0.432L8.80026 6.608L14.9443 0.464C15.08 0.319548 15.2435 0.203991 15.4249 0.12426C15.6064 0.0445277 15.8021 0.00226295 16.0003 0C16.4246 0 16.8316 0.168571 17.1316 0.468629C17.4317 0.768687 17.6003 1.17565 17.6003 1.6C17.604 1.79616 17.5676 1.99102 17.4933 2.17261C17.419 2.3542 17.3084 2.5187 17.1683 2.656L10.9443 8.8L17.1683 15.024C17.432 15.282 17.5866 15.6313 17.6003 16C17.6003 16.4243 17.4317 16.8313 17.1316 17.1314C16.8316 17.4314 16.4246 17.6 16.0003 17.6C15.7963 17.6085 15.5929 17.5744 15.4028 17.5001C15.2128 17.4257 15.0403 17.3126 14.8963 17.168L8.80026 10.992L2.64026 17.152C2.50507 17.2916 2.34356 17.4031 2.16506 17.48C1.98656 17.5569 1.7946 17.5977 1.60026 17.6C1.17591 17.6 0.768948 17.4314 0.468889 17.1314C0.168831 16.8313 0.000260331 16.4243 0.000260331 16C-0.00347006 15.8038 0.032925 15.609 0.107212 15.4274C0.181499 15.2458 0.292112 15.0813 0.43226 14.944L6.65626 8.8L0.43226 2.576C0.168556 2.31801 0.0139237 1.96866 0.000260331 1.6C0.000260331 1.17565 0.168831 0.768687 0.468889 0.468629C0.768948 0.168571 1.17591 0 1.60026 0C1.98426 0.0048 2.35226 0.16 2.62426 0.432Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.bf0abc181164e8f10ed5d6d9869e4b60.svg";
export { ForwardRef as ReactComponent };